export const ReturnMode = Object.freeze({
  Basic: 'BASIC',
  Ingested: 'INGESTED',
  Advanced: 'ADVANCED',
});

export type ReturnModes = (typeof ReturnMode)[keyof typeof ReturnMode];
